import { css } from '@emotion/css';
import { Button, ButtonProps, Modal, ThemeProvider, createTheme, styled } from '@mui/material';
import { memo } from 'react';
import { colors } from 'styles/colors';

const ColorButtonConfirm = styled(Button)<ButtonProps>(() => ({
    color: 'white',
    backgroundColor: colors.primaryButtonBackground,
    width: '6rem',
    height: '2.4rem',
    fontSize: '14px',
    fontWeight: '400',
    fontFamily: 'Figtree',
    padding: '5px',
    textTransform: 'none',
    '&:hover': {
        backgroundColor: colors.primaryButtonBackground,
    },
    borderRadius: '0.5rem',
}));

type ErrorSurveyModalProps = {
    open: boolean;
    text?: string;
    onClose: () => void;
};

const theme = createTheme({
    components: {
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    marginTop: '0rem',
                },
            },
        },
    },
});

const ErrorSurveyModal = memo(({ open, text, onClose }: ErrorSurveyModalProps) => {
    return (
        <ThemeProvider theme={theme}>
            <Modal
                sx={{ border: 'none', outline: 'none' }}
                open={open}
                onClose={onClose}
                style={{ backgroundColor: 'none' }}
            >
                <div className={styles.infoModal}>
                    <div className={styles.modalContent}>
                        <div className={styles.modalBody}>{text}</div>
                        <div className={styles.modalFooter}>
                            <div className={styles.button}>
                                <ColorButtonConfirm onClick={onClose} variant="contained">
                                    Ok
                                </ColorButtonConfirm>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </ThemeProvider>
    );
});

const styles = {
    infoModal: css({
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '300px',
        backgroundColor: colors.backgroundLight,
        borderRadius: '10px',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        padding: '1.5rem',
        outline: 'none',
    }),
    modalContent: css({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    }),
    modalBody: css({
        flex: 1,
        marginBottom: '1.5rem',
        fontSize: '1rem',
        color: colors.primaryText,
        textAlign: 'left',
        fontFamily: 'Figtree',
    }),
    modalFooter: css({
        display: 'flex',
        justifyContent: 'center',
    }),
    button: css({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'Figtree',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: 'normal',
    }),
};

export default ErrorSurveyModal;
